// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "c31e03f5bb78fc10566a03417fb1a734" + ".js";
};